/**
 * Product Comparison Swipe Functionality
 * Enables horizontal scrolling with mouse drag and touch swipe on mobile/tablet
 */
(function() {
  const container = document.querySelector('[data-product-comparison-container]');
  if (!container) return;
  
  // Enable horizontal scrolling on mobile/tablet
  let isDown = false;
  let startX;
  let scrollLeft;

  container.addEventListener('mousedown', (e) => {
    if (window.innerWidth >= 1024) return; // Only on mobile/tablet
    isDown = true;
    container.classList.add('active');
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  });

  container.addEventListener('mouseleave', () => {
    isDown = false;
    container.classList.remove('active');
  });

  container.addEventListener('mouseup', () => {
    isDown = false;
    container.classList.remove('active');
  });

  container.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 2;
    container.scrollLeft = scrollLeft - walk;
  });

  // Touch events for mobile swipe
  let touchStartX = 0;
  let touchScrollLeft = 0;

  container.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].pageX;
    touchScrollLeft = container.scrollLeft;
  }, { passive: true });

  container.addEventListener('touchmove', (e) => {
    const touchX = e.touches[0].pageX;
    const walk = (touchStartX - touchX);
    container.scrollLeft = touchScrollLeft + walk;
  }, { passive: true });
})();
